import React from 'react';

const TermsAndConditions: React.FC = () => {
  return (
    <div style={{
      fontFamily: '"Helvetica Neue", sans-serif',
      background: '#fefefe',
      color: '#212121',
      margin: 0,
      padding: 0,
      minHeight: '100vh'
    }}>
      <div className="policy-page-inner" style={{
        maxWidth: '880px',
        margin: '20px auto',
        padding: '24px',
        background: '#ffffff',
        borderRadius: '10px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
      }}>
        <h1 style={{
          textAlign: 'center',
          color: '#0C7B3D',
          fontSize: '2em',
          marginBottom: '1em'
        }}>
          Terms of Service
        </h1>
        <p style={{ textAlign: 'center', fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          Last Updated: January 16, 2026
        </p>
        
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          Please read this carefully before using the service.
        </p>
        <h4 style={{
          color: '#0C7B3D',
          marginTop: '1.2em',
          fontSize: '1.2em'
        }}>
          Welcome to Fairloner!
        </h4>
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          The Fairloner service ("Service") allows you to qualify for borrowing small amounts over short periods of time (each referred to as a "Loan"). The Service is operated by Fairloner ("we," "us," or "Fairloner") and is subject to these Terms of Service ("Terms").
        </p>
      
        <h2 style={{
          color: '#F4B400',
          marginTop: '2em',
          borderLeft: '5px solid #0C7B3D',
          paddingLeft: '12px'
        }}>Loan Product Information:</h2>

        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>1.Loan amount: ₦2,000 - ₦300,000</p>

        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>2.Loan Term: Minimum of 90 days, up to a maximum of 365 days</p>

        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>3.Annual Percentage Rate (APR): 36%</p>

        <h4 style={{
          color: '#0C7B3D',
          marginTop: '1.2em',
          fontSize: '1.2em'
        }}>
          Loan example:
        </h4>

        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          For instance, if you borrow ₦2,000 with an APR of 36% for a 90-day term and choose to repay in monthly installments:
        </p>

        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>Monthly Interest Rate: 3%</p>

        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>Monthly Payment = [Principal × Monthly Interest Rate × (1 + Monthly Interest Rate)^n] / [(1 + Monthly Interest Rate)^n - 1]</p>

        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>Monthly Payment = [2000 × 3% × (1 + 3%)^3] / [(1 + 3%)^3 - 1] = ₦707.06</p>

        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>Total Repayment Over 3 Months: ₦707.06 × 3 = ₦2,121.18</p>

        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>Total Interest Payable: ₦2,121.18 – ₦2,000 = ₦121.18</p>

        <h2 style={{
          color: '#F4B400',
          marginTop: '2em',
          borderLeft: '5px solid #0C7B3D',
          paddingLeft: '12px'
        }}>Usage Conditions</h2>

        <div style={{ marginBottom: '20px' }}>
          <h4 style={{
            color: '#0C7B3D',
            marginTop: '1.2em',
            fontSize: '1.2em',
            marginBottom: '10px'
          }}>
            1. This is a legally binding contract.
          </h4>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
            These Terms constitute a legally binding contract. You may not use the Service if you do not agree to these Terms. By using any part of the Service, you are deemed to have accepted these Terms. If you are under eighteen (18) years of age, you are not permitted to use the Service.
          </p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h4 style={{
            color: '#0C7B3D',
            marginTop: '1.2em',
            fontSize: '1.2em',
            marginBottom: '10px'
          }}>
            2. You are required to accept our Privacy Policy.
          </h4>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
            To provide you with the Service, you must authorize us to collect certain personal information as described in our Privacy Policy. The Privacy Policy, which governs the Service, is attached to and forms part of these Terms ("Privacy Policy"). By accepting these Terms and using the Service, you consent to and authorize the collection and use of your personal information in accordance with the Privacy Policy.
          </p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h4 style={{
            color: '#0C7B3D',
            marginTop: '1.2em',
            fontSize: '1.2em',
            marginBottom: '10px'
          }}>
            3. You must provide truthful information.
          </h4>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
            You agree to provide true, accurate, and complete information about yourself as requested ("Account Data"), and you confirm that you have full authority to provide this data, including, in particular, information regarding the person you have listed as your emergency contact. You agree to indemnify and hold us fully harmless against any demands or claims arising from any third-party information you provide to us during your use of the Service, including information related to your emergency contact. Additionally, you agree to keep your Account Data up to date.
          </p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h4 style={{
            color: '#0C7B3D',
            marginTop: '1.2em',
            fontSize: '1.2em',
            marginBottom: '10px'
          }}>
            4. You authorize us to verify the information you provide.
          </h4>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
            You hereby authorize us to conduct information verification checks on you whenever we consider it necessary. Furthermore, you expressly permit us to share your Account Data and personal information with verification providers, information suppliers, and third parties acting on behalf of Fairloner to verify your information. This includes, but is not limited to, qualification and certification verification, employer background checks, employment verification and references, criminal record checks, driver's license and passport validation, identity verification, and any other personal information required to validate and confirm your details. You understand and agree that your consent remains valid indefinitely for all current and future requests related to personal information verification, screening, validation, and confirmation concerning yourself.
          </p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h4 style={{
            color: '#0C7B3D',
            marginTop: '1.2em',
            fontSize: '1.2em',
            marginBottom: '10px'
          }}>
            5. You are responsible for keeping your account secure.
          </h4>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
            You are responsible for keeping your password and account confidential. Additionally, you bear full responsibility for all activities conducted through your account or password. You agree to notify us immediately if you become aware of any unauthorized use of your account or any other security breach. Any use of your account by you or any other person will be considered authorized, and you agree to indemnify us and waive any claims related to unauthorized use of your account.
          </p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h4 style={{
            color: '#0C7B3D',
            marginTop: '1.2em',
            fontSize: '1.2em',
            marginBottom: '10px'
          }}>
            6. Our fee is charged in addition to the amount you borrow.
          </h4>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
            After completing the account registration process, you may be given the opportunity to apply for Loans of certain amounts. We reserve the right to decline any Loan application for any reason. However, if we accept your application and approve a Loan, we will charge a fee that you must pay in addition to repaying the borrowed amount ("Origination Fee"). The Origination Fee payable will be disclosed alongside the loan amount at the time you apply for each Loan. The Loan amount credited to your Fairloner Account will be the loan amount minus the applicable Origination Fee.
          </p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h4 style={{
            color: '#0C7B3D',
            marginTop: '1.2em',
            fontSize: '1.2em',
            marginBottom: '10px'
          }}>
            7. You must repay your Loan by the Due Date or choose to rollover your Loan.
          </h4>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
            You must repay the Loan by the date specified at the time the Loan is granted ("Due Date"). It is important that both the Loan and the Origination Fee are repaid by the Due Date. If you fail to do so, we may, at our discretion, rollover your Loan for a period determined by us ("Rollover Period") and charge an additional fee ("Rollover Fee") of two percent (2%) per day. You are required to repay the loan principal, Origination Fee, and Rollover Fee by the end of the Rollover Period.
          </p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h4 style={{
            color: '#0C7B3D',
            marginTop: '1.2em',
            fontSize: '1.2em',
            marginBottom: '10px'
          }}>
            8. If you fail to repay the Loan, you will be considered in default.
          </h4>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
            If you have not repaid the Loan amount and associated fees by the end of the Rollover Period, you will be considered in default. We may report this default to credit reference bureaus licensed under the Credit Reporting Act 2017 within 28 (twenty-eight) days of your default. Such a report may impact your future borrowing ability. You will be responsible for any reasonable costs we or our service providers incur in collecting the payment, in accordance with applicable law. Overdue amounts will be rounded up to the nearest whole Nigerian Naira.
          </p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h4 style={{
            color: '#0C7B3D',
            marginTop: '1.2em',
            fontSize: '1.2em',
            marginBottom: '10px'
          }}>
            9. You grant us a mandate.
          </h4>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
            You expressly request, instruct, and authorize us to debit any of your accounts registered with your Bank Verification Number ("BVN") and/or your Paycom Nigeria OPay Wallet in cases where your BVN-linked accounts lack sufficient funds to repay the Loan. This will be done in accordance with any direct debit instructions issued and provided to you by us. The debited amount may include the Loan principal, Origination Fee, Rollover Fee, or any other applicable fees necessary to settle the payment due on the Due Date, or before or after the Rollover Period. All such debits made by us under this direct debit authorization shall be considered as if personally signed by you. You understand that these withdrawals will be processed via electronic funds transfer and that each withdrawal will appear as a transaction on your bank statement. You also expressly agree to bear any bank charges related to this authorization.
          </p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h4 style={{
            color: '#0C7B3D',
            marginTop: '1.2em',
            fontSize: '1.2em',
            marginBottom: '10px'
          }}>
            10. We may contact you and/or your emergency contact.
          </h4>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
            You expressly agree that, as part of the Service, you may occasionally receive communications from us via text message (SMS) or email, including promotional newsletters or other information related to the Service. You may opt out of receiving promotional messages by following the unsubscribe instructions included in those messages. However, opting out of promotional messages does not exempt you from receiving service-related communications. You also expressly authorize us to contact your emergency contact to verify your information if we are unable to reach you or have not received your repayment. You confirm that your emergency contact has consented to sharing their information with us and to being contacted regarding your use of the Service. If we are unable to reach you or your emergency contact, you further authorize us to contact any and all individuals in your contact list.
          </p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h4 style={{
            color: '#0C7B3D',
            marginTop: '1.2em',
            fontSize: '1.2em',
            marginBottom: '10px'
          }}>
            11. You must respect our rights related to the Service.
          </h4>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
            We grant you a limited, non-transferable, personal right and license to use the Service and any related software applications through which it is provided. You may not copy, decompile, reverse engineer, disassemble, attempt to derive the source code of, modify, or create derivative works of the software—except where such restrictions are prohibited by applicable law or to the limited extent allowed by the licensing terms governing any open-source components included in the software.
          </p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h4 style={{
            color: '#0C7B3D',
            marginTop: '1.2em',
            fontSize: '1.2em',
            marginBottom: '10px'
          }}>
            12. We may discontinue the Service at any time.
          </h4>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
            We may, at our sole discretion and at any time, terminate your access to the Service or discontinue providing the Service or any part of it, with or without prior notice. You agree that we will not be liable to you or any third party for any modifications, discontinuation of the Service, or termination or suspension of your access.
          </p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h4 style={{
            color: '#0C7B3D',
            marginTop: '1.2em',
            fontSize: '1.2em',
            marginBottom: '10px'
          }}>
            13. Legally Permitted Use of the Service
          </h4>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
            We and our affiliated entities strictly enforce policies against money laundering, terrorism financing, and conducting business with entities or individuals located in territories subject to trade sanctions or who are individually sanctioned ("Policies"). In addition to other prohibitions set forth in these Terms & Conditions, you are prohibited from using the Platform to: (a) engage in any unlawful activities; (b) solicit others to participate in unlawful acts; (c) violate any international, federal, provincial, state, or local laws, regulations, or ordinances; (d) infringe upon or violate our intellectual property rights or those of others; (e) harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate based on gender, sexual orientation, religion, ethnicity, race, age, national origin, or disability; (f) submit false or misleading information; (g) upload or transmit viruses or malicious code that could disrupt the functionality or operation of the Service, related websites, other websites, or the Internet; (h) collect or track personal information of others; (i) engage in spamming, phishing, pharming, pretexting, spidering, crawling, or scraping; (j) use the Platform for any obscene or immoral purpose; (k) interfere with or circumvent security features of the Service, related websites, other websites, or the Internet; or (l) violate any laws including but not limited to acts of fraud, money laundering, bribery, corruption, or use any loaned amounts for illegal or illicit purposes. You also agree that any payments made to us are not proceeds of illegal activities. If we determine or suspect that the Platform is being used for illegal or illicit purposes or in violation of our Policies, we reserve the right to immediately terminate your access to the Services and to report your conduct to the relevant legal authorities for investigation and possible prosecution.
          </p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h4 style={{
            color: '#0C7B3D',
            marginTop: '1.2em',
            fontSize: '1.2em',
            marginBottom: '10px'
          }}>
            14. The Service is provided without any warranties or guarantees.
          </h4>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
            The service is provided "as is" without any warranties of any kind. We and our suppliers expressly disclaim all warranties related to the service, including all implied warranties of merchantability, fitness for a particular purpose, title, and non-infringement. If you are dissatisfied with any part of the service or these terms, your sole and exclusive remedy is to stop using the service.
          </p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h4 style={{
            color: '#0C7B3D',
            marginTop: '1.2em',
            fontSize: '1.2em',
            marginBottom: '10px'
          }}>
            15. We are not liable for any damages you may incur.
          </h4>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
            In no event shall we or our suppliers be liable for any direct, indirect, punitive, incidental, special, or consequential damages—including, without limitation, damages for loss of use, data, profits, or any other losses—arising out of or in any way related to the use or performance of the service, the delay or inability to use the service, the provision or failure to provide the service, or any loan obtained through the service. This applies regardless of whether the claim is based on contract, tort, negligence, strict liability, or any other legal theory, even if we or our suppliers have been advised of the possibility of such damages.
          </p>
        </div>

        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          This contract is governed by and shall be construed in accordance with the laws of Nigeria, without regard to its conflict of laws principles. Any disputes relating to the interpretation, validity, or enforcement of this Agreement that cannot be resolved by mutual agreement shall be submitted to arbitration conducted in English before a sole arbitrator in Lagos, Nigeria, which shall serve as the seat of arbitration. The arbitration will be conducted under the Rules of Arbitration of the Chartered Institute of Arbitrators of the United Kingdom. The arbitral award shall be final, binding on the Parties, and may be enforced as a court order. The Parties hereby unconditionally consent to the jurisdiction of the High Court of Lagos, Nigeria, for enforcement purposes. Nothing in this Agreement shall prevent Fairloner from seeking injunctive relief or other provisional remedies from any court with jurisdiction over the Parties and the subject matter to protect Fairloner's name, proprietary information, trade secrets, know-how, or other intellectual property rights.
        </p>

        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          No alteration, variation, or agreed cancellation of this Agreement, including this paragraph, shall have any effect unless expressly authorized by us.
        </p>

        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          This Agreement constitutes the entire agreement between the Parties regarding its subject matter, and no warranties or representations of any kind other than those expressly stated in this Agreement have been made by either Party.
        </p>

        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          No relaxation or indulgence shown by any Party to another under this Agreement shall prejudice or be considered a waiver of that Party's rights under this Agreement.
        </p>

        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          Each provision of this Agreement (except those essential by law for the Agreement to be valid and binding) shall be considered separate and severable from the rest. If any provision (other than those essential for validity) is found invalid or unenforceable by a court with proper jurisdiction, the remaining provisions shall continue to be fully effective despite such invalidity or unenforceability.
        </p>

        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          Any substantive provision contained within or as part of any interpretative provision of this Agreement shall be effective according to its terms, regardless of the context in which it appears.
        </p>

        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          We may modify these Terms at any time in the future without prior notice. Changes will be posted on [the website] or its successor URL. It is your responsibility to stay informed of any updates, as you are bound by the latest version of the Terms.
        </p>

        <div style={{
          textAlign: 'center',
          color: '#666',
          fontSize: '0.9em',
          marginTop: '50px'
        }}>
          ©.2025 JEJELY ULTIMATE LIMITED. Made for Nigeria.
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
